export const FirmSignature = ({ size = "text-2xl sm:text-3xl lg:text-4xl", className = "", testid = "firm-signature" }) => (
  <p
    data-testid={testid}
    className={`font-serif font-bold leading-tight tracking-wide ${size} ${className}`}
    style={{
      color: "#D4AF37",
      WebkitTextStroke: "1.1px #A31621",
      paintOrder: "stroke fill",
      textShadow: "0 2px 22px rgba(0,0,0,0.6), 0 0 42px rgba(212,175,55,0.18)",
    }}
  >
    Galano-Pacifico Law Firm &amp; International Partners
  </p>
);
